import { useState, useEffect, useMemo, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect, useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import NewNote from '../NewNotes/newNote';
import { ehandoverAPI, systemAPI } from '../../../../apis';
import { AddTotal, ReduceTotal, PinNotification, hideLoginPopup } from '../../../../redux/actions';
import { getRoleTypeColor } from '../../../../utils/eHandoverUtil';
import { LoginPop } from '../../../../components/Login';
import Menu from './menu';

const useStyles = makeStyles(() => ({
  root: {
    padding: '2.188rem 3.438rem 4.063rem',
    height: '100vh',
    '&>div:nth-child(2)': {
      margin: '1.063rem 0 3.75rem 0',
    },
  },
}));

function Details({ match, list, addTotal, reduceTotal, wardId, history, pinNotification, userRole, sinkCompletedToBottom }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const loginInfo = useSelector((state) => state.loginInfo);
  const showLogin = useSelector((state) => state.LoginPopupReducer);
  const [task, setTask] = useState([]);
  const [tags, setTags] = useState([]);
  const [deletedFlag, setDeletedFlag] = useState(false);
  const [accessControl, setAccessControl] = useState(null);
  const [staffList, setStaffList] = useState([]);
  // 标记是否有待执行的操作,登录后继续执行
  const [pendingAction, setPendingAction] = useState(null);
  const [individualUsers, setIndividualUsers] = useState(null);

  const info = useMemo(() => {
    let index = 0;
    let length = 0;
    let noteList = [];
    let type = match.params.type;
    let postday = false;

    switch (type) {
      case 'task':
        index = list.noteList.findIndex((item) => {
          return item === match.params.id;
        });
        length = list.noteList.length;
        noteList = list.noteList;
        break;
      case 'deleted':
        index = list.deleteList.findIndex((item) => {
          return item === match.params.id;
        });
        length = list.deleteList.length;
        noteList = list.deleteList;
        break;
      case 'postDay':
        index = list.postdayList.findIndex((item) => {
          return item === match.params.id;
        });
        length = list.postdayList.length;
        noteList = list.postdayList;
        postday = true;
        break;
      case 'followUp':
        index = list.followList.findIndex((item) => {
          return item === match.params.id;
        });
        length = list.followList.length;
        noteList = list.followList;
        break;
      case 'notification':
        index = list.notification.findIndex((item) => {
          return Number(item.notificationId) === Number(match.params.id);
        });
        length = list.notification.length;
        noteList = list.notification;
        break;
      default:
        break;
    }

    return {
      taskId: Number(match.params.id),
      index,
      length,
      noteList,
      type,
      postday,
    };
  }, [match.params]);

  const getAccessControlListAPI = useCallback(async () => {
    try {
      const { result } = await ehandoverAPI.getSettingAccess();
      setAccessControl(result);
    } catch (error) {}
  }, []);

  // get staff list API
  const getStaffListAPI = async () => {
    try {
      const time = moment().format('YYYY-MM-DD');
      const { result } = await ehandoverAPI.getSrsStaffList(
        {
          wardId,
          timeStart: time,
          timeEnd: time,
        },
        { isHideLoading: true }
      );
      let newList = [];
      if (Array.isArray(result.roster_list) && result.roster_list.length > 0) {
        newList = _.map(result.roster_list, (item) => {
          return {
            id: item.corp_id,
            text: item.staff_name || item.corp_id,
            value: item.corp_id.toUpperCase(),
            color: getRoleTypeColor(item?.role ?? ''),
          };
        });
      }
      setStaffList(newList);
    } catch (error) {}
  };

  // get task API
  const getTaskAPI = async ({
    id,
    select = [
      'ID',
      'TITLE',
      'DESCRIPTION',
      'STATUS',
      'GROUP_ID',
      'CREATED_BY',
      'CREATED_DATE',
      'COMMENTS_COUNT',
      'DATE_START',
      'UF_TASK_WEBDAV_FILES',
      'CHECKLIST',
      'PRIORITY',
      'MARK',
    ],
  }) => {
    try {
      const { result } = await ehandoverAPI.getTask({
        select,
        taskId: id,
      });
      setTags([...result.tags]);
      setTask([{ ...result.task }]);
    } catch (error) {
      console.log('-----Get Task error----->', error);
    }
  };

  // delete task API
  const deleteTaskAPI = async (TASK_ID, name) => {
    try {
      await ehandoverAPI.postDeleteTask({
        taskId: TASK_ID,
        deletedBy: name,
      });
      await getTaskAPI({ id: info.taskId });
      setDeletedFlag(true);
    } catch (error) {
      console.log('-----Delete Task error----->', error);
    }
  };

  // pin task API
  const pinTaskAPI = async ({ taskId, pin }) => {
    try {
      await ehandoverAPI.postPinTask({
        taskId,
        priority: pin,
      });
      await getTaskAPI({ id: info.taskId });
    } catch (error) {
      console.log('-----Pin/UnPin Task error----->', error);
    }
  };

  // pin noti API
  const pinNotiAPI = async ({ taskId, pin }) => {
    try {
      await systemAPI.pinNotification({
        notificationId: taskId,
        isPin: Number(pin) === 1 ? '0' : '1',
      });
      pinNotification({ index: info.index, content: { ...data[0], pin: Number(pin) !== 1 } });
      setTask([list.notification[info.index]]);
    } catch (error) {
      console.log('-----Pin/UnPin Noti error----->', error);
    }
  };

  const getIndividualUsers = useCallback(async () => {
    try {
      const { result } = await ehandoverAPI.getIndividualUserList();
      const newRoomTypeList = _.map(result?.roomTypeList ?? [], (roomItem) => ({
        ...roomItem,
        color: roomItem?.role ? getRoleTypeColor(roomItem?.role ?? '') : 'unset',
      }));
      const newStaffList = _.map(result?.staffList ?? [], (roomItem) => ({
        ...roomItem,
        color: getRoleTypeColor(roomItem?.role ?? ''),
      }));
      setIndividualUsers({ roomTypeList: newRoomTypeList, staffList: newStaffList });
    } catch (error) {}
  }, []);
  

  const getTaskChecklist = (checklist) => {
    let newChecklist = [];
    if (_.isObject(checklist)) {
      newChecklist = _.values(checklist);
    }
    newChecklist = _.map(newChecklist, (item) => ({
      ...item,
      ID: item?.id,
      TASK_ID: item?.taskId,
      CREATED_BY: item?.createdBy,
      PARENT_ID: item?.parentId,
      TITLE: item?.title,
      SORT_INDEX: item?.sortIndex,
      IS_COMPLETE: item?.isComplete,
      IS_IMPORTANT: item?.isImportant,
      TOGGLED_BY: item?.toggledBy,
      TOGGLED_DATE: item?.toggledDate,
      MEMBERS: item?.members,
      ATTACHMENTS: item?.attachments,
    }));
    return newChecklist;
  };

  const data = useMemo(() => {
    let noteList = [];

    if (Array.isArray(task) && task.length > 0) {
      noteList = _.map(task, (item) => {
        if (info.type === 'notification') {
          return { ...item, detail: true };
        }
        return {
          TASK_ID: item.id,
          name: item.creator.name,
          time: item.dateStart ?? item.createdDate,
          context: item.description,
          tags: tags,
          deletedDate: item.deletedDate,
          deletedBy: item.deletedBy,
          pin: item.priority !== '1',
          commentsTotal: item.commentsCount ?? 0,
          ufTaskWebdavFiles: item.ufTaskWebdavFiles,
          detail: true,
          comment: true,
          addTotal: addTotal,
          reduceTotal: reduceTotal,
          itemData: { ...item, tags },
          taskCheckList: getTaskChecklist(item?.checklist),
        };
      });
    }

    return noteList;
  }, [task, tags]);

  const leftId =
    info.type === 'notification' ? info.noteList[info.index - 1]?.notificationId : info.noteList[info.index - 1];
  const rightId =
    info.type === 'notification' ? info.noteList[info.index + 1]?.notificationId : info.noteList[info.index + 1];

  useEffect(() => {
    let ctrl = true;
    if (ctrl) {
      if (match.params.type === 'notification') {
        setTask([list.notification[info.index]]);
      } else {
        (async () => {
          await getTaskAPI({ id: info.taskId });
        })();
        (async () => {
          await getAccessControlListAPI();
        })();
        (async () => {
          await getStaffListAPI();
        })();
        (async () => {
          await getIndividualUsers();
        })();
      }
    }
    return () => {
      ctrl = false;
    };
  }, [match.params.id]);

  // 监听登录状态变化,登录成功后继续check/uncheck的操作
  useEffect(() => {
    if (pendingAction && loginInfo?.flag && _.isFunction(pendingAction?.callback)) {
      const completeName = loginInfo?.displayName || loginInfo?.corpID;
      pendingAction?.callback(completeName, {corpId: loginInfo?.corpID ?? ""});
      setPendingAction(null);
    }
  }, [loginInfo?.flag, pendingAction]);


  return (
    <div className={classes.root}>
      <Menu
        left={info.index !== 0}
        leftId={leftId}
        right={info.length !== info.index + 1}
        rightId={rightId}
        history={history}
        type={info.type}
        deletedFlag={deletedFlag}
        backID="menu1"
        leftID="menu2"
        rightID="menu3"
      />
      {data.length > 0 &&
        data.map((item, index) => {
          console.log(item);
          const taskData = item?.itemData;
          const isUpdate = item?.itemData?.isUpdate;
          const customRecurrenceConfig ={
            customRecurrence: taskData?.customRecurrence,
            intervalValue: taskData?.intervalValue,
            intervalType: taskData?.intervalType,
            daysOfWeek: taskData?.daysOfWeek ? taskData?.daysOfWeek?.split(',') : [],
            monthDayOfWeek: taskData?.monthDayOfWeek,
            monthRepeatType: taskData?.monthRepeatType,
            endDate: taskData?.endDate ? moment(taskData?.endDate).format('yyyy-MM-DD HH:mm:ss') : null,
          };
          return (
          <NewNote
            id={`${index}viewAll`}
            key={`${item.taskId}ViewAll`}
            {...item}
            postday={info.postday}
            type={deletedFlag ? 'deleted' : info.type}
            deleteTaskAPI={deleteTaskAPI}
            pinTaskAPI={info.type === 'notification' ? pinNotiAPI : pinTaskAPI}
            handleSearch={() => getTaskAPI({ id: info.taskId })}
            accessControl={accessControl}
            staffList={staffList}
            setPendingAction={setPendingAction}
            isDetailPage={true}
            loginInfo={loginInfo}
            userRole={userRole}
            customRecurrenceConfig={customRecurrenceConfig}
            sinkCompletedToBottom={sinkCompletedToBottom}
            individualUsers={individualUsers}
            isUpdate={isUpdate}
          />
        )})}
      <Menu
        left={info.index !== 0}
        leftId={leftId}
        right={info.length !== info.index + 1}
        rightId={rightId}
        history={history}
        type={info.type}
        deletedFlag={deletedFlag}
        backID="menu4"
        leftID="menu5"
        rightID="menu6"
      />
      {showLogin && (
        <LoginPop closehandle={() => dispatch(hideLoginPopup())} submitHandle={() => dispatch(hideLoginPopup())} />
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  list: state.NoteList,
  wardId: state.loginInfo.wardId,
  userRole: state.userRole,
  sinkCompletedToBottom: state.ehdSetting.sinkCompletedChecklist
});

const mapDispatchToProps = (dispatch) => ({
  addTotal: (num) => {
    dispatch(AddTotal(num));
  },
  reduceTotal: (num) => {
    dispatch(ReduceTotal(num));
  },
  pinNotification: (data) => {
    dispatch(PinNotification(data));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Details);
